import { useEffect, useState, useContext, useRef } from "react";
import { Stack, Box, Cluster } from "../../shared/layouts";
import Card from "../../shared/Card";
import Header from "../../shared/Header";
import Button from "../../shared/Button";
import axios from "axios";
import PreventUnload from "../../shared/PreventUnload";
import Input from "../../shared/Input";
import Labeled from "../../shared/WithLabel";
import useForm from "../../../hooks/useForm";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../context/UserContext";
import MessagebarContext from "../../../context/MessagebarContext";
import Loader from "../../shared/Loader";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const EditName = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [data, handleData, setData] = useForm({});
  const [errors, setErrors] = useState({});
  const { SettingsIcon } = useIconLibrary();

  const navigate = useNavigate();
  const { setChangedDataWithoutSaving } = useContext(UserContext);
  const { setSuccesMessage, setAlertMessage } = useContext(MessagebarContext);

  const mountedRef = useRef(true);

  useEffect(() => {
    axios.get("/user/settings/name/change").then((res) => {
      if (!mountedRef.current) return null;
      setData(res.data);
      setIsLoading(false);
    });
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    setChangedDataWithoutSaving(false);
  }, []);

  const save = (e) => {
    e.preventDefault();
    setIsLoading(true);

    axios
      .put("/user/settings/name/change", data, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      .then(() => {
        setSuccesMessage();
        setErrors([]);
        setChangedDataWithoutSaving(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setErrors(err.response.data.errors);
        setAlertMessage();
        setIsLoading(false);
      });
  };

  return (
    <PreventUnload>
      {isLoading && <Loader />}
      <Stack
        as="form"
        onSubmit={save}
        space="xl"
        width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}
      >
        <Header
          title={t("Instellingen")}
          icon={<SettingsIcon width="2rem" height="2rem" />}
          variant="page"
        />
        <Card>
          <Stack space="m" width="100%">
            <Header title={t("Naam wijzigen")} variant="section" />
            <Cluster flex={1}>
              <Labeled label={t("Initialen")}>
                <Input
                  name="initials"
                  value={data.initials}
                  onChange={handleData}
                  errors={errors?.initials}
                />
              </Labeled>
              <Box />
            </Cluster>
            <Cluster flex={1}>
              <Labeled label={t("Voornaam")}>
                <Input
                  name="first_name"
                  value={data.first_name}
                  onChange={handleData}
                  errors={errors?.first_name}
                />
              </Labeled>
              <Box />
            </Cluster>
            <Cluster flex={1}>
              <Labeled label={t("Tussenvoegels")}>
                <Input
                  name="addition"
                  value={data.addition}
                  onChange={handleData}
                  errors={errors?.addition}
                />
              </Labeled>
              <Box />
            </Cluster>
            <Cluster flex={1}>
              <Labeled label={t("Achternaam")}>
                <Input
                  name="last_name"
                  value={data.last_name}
                  onChange={handleData}
                  errors={errors?.last_name}
                />
              </Labeled>
              <Box />
            </Cluster>
            <Cluster flex={1}>
                <Labeled label={t("Wachtwoord")}>
                  <Input
                    type="password"
                    name="password"
                    value={data.password}
                    onChange={handleData}
                    errors={errors?.password}
                    autoComplete="new-password"
                  />
                </Labeled>
              <Box />
            </Cluster>
          </Stack>
          <Cluster
            mt="xl"
            display="flex"
            maxWidth="100%"
            justifyContent="flex-end"
            hGap="m"
          >
            <Button
              variant="primary-outline"
              onClick={() => {
                navigate("/user/settings");
              }}
            >
              {t('Annuleren')}
            </Button>
            <Button variant="primary" type="submit">
              {t('Opslaan')}
            </Button>
          </Cluster>
        </Card>
      </Stack>
    </PreventUnload>
  );
};

export default EditName;
